import * as bodySegmentation from '@tensorflow-models/body-segmentation';
import * as poseDetection from '@tensorflow-models/pose-detection';

export const MODEL_BACKEND_MAP = {
  [bodySegmentation.SupportedModels.MediaPipeSelfieSegmentation]: [
    'mediapipe-gpu',
    'tfjs-webgl',
  ],
  [bodySegmentation.SupportedModels.BodyPix]: ['tfjs-webgl'],
  [poseDetection.SupportedModels.BlazePose]: ['mediapipe-gpu', 'tfjs-webgl'],
};
